// extracted by mini-css-extract-plugin
export default {"pausebutton":"pause_pausebutton__FG6eX"};